/* eslint-disable */
import isFn from '@dcode/is/fn/fn';

export const {
	getOwnPropertySymbols,
	getOwnPropertyNames,
	getPrototypeOf,
} = Object;

export const getContextKeys = (context) => {
	let props = [];
	do {
		const names = getOwnPropertyNames(context)
			.concat(getOwnPropertySymbols(context).map((sym) => sym.toString()))
			.filter((value, index, list) =>
				isFn(context[value])
				&& value !== 'constructor'
				&& (index == 0 || value !== list[index - 1])
				&& props.indexOf(value) === -1
			)
		props = props.concat(names);
	} while ((context = getPrototypeOf(context)) && getPrototypeOf(context));
	return props;
};

export default getContextKeys;
